import authType from '@/store/type/authType'
import store from '@/store/store'

export default function () {
    if (store.getters[authType.getters.IS_RESTAURANT_ADMIN])
        return { source: 'restaurant_admin' }
    return { source: 'admin' }
}
